import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const Voicemail = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M7.99984 6.66669C6.16678 6.66669 4.6665 8.16697 4.6665 10C4.6665 11.8331 6.16678 13.3334 7.99984 13.3334H15.9998C17.8329 13.3334 19.3332 11.8331 19.3332 10C19.3332 8.16697 17.8329 6.66669 15.9998 6.66669C14.1668 6.66669 12.6665 8.16697 12.6665 10C12.6665 10.752 12.9283 11.4407 13.3527 12H10.647C11.0713 11.4407 11.3332 10.752 11.3332 10C11.3332 8.16697 9.83289 6.66669 7.99984 6.66669ZM7.99984 8.00002C9.1123 8.00002 9.99984 8.88755 9.99984 10C9.99984 11.1125 9.1123 12 7.99984 12C6.88737 12 5.99984 11.1125 5.99984 10C5.99984 8.88755 6.88737 8.00002 7.99984 8.00002ZM15.9998 8.00002C17.1123 8.00002 17.9998 8.88755 17.9998 10C17.9998 11.1125 17.1123 12 15.9998 12C14.8874 12 13.9998 11.1125 13.9998 10C13.9998 8.88755 14.8874 8.00002 15.9998 8.00002Z",
      fill: "currentColor"
    }
  ) }),
  "Voicemail"
);
export {
  Voicemail
};
